module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "head"
  }, [_c('a', {
    staticClass: "back tl",
    attrs: {
      "href": "javascript:history.back(-1)"
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "tc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('small', {
    staticClass: "font_18 co_f"
  }, [_vm._v("评价列表")])])]), _vm._v(" "), _c('main', [_c('div', {
    staticClass: "comment-view"
  }, [_c('ul', {
    staticClass: "rating_list_ul"
  }, [_c('li', {
    staticClass: "rating_list_li"
  }, [_c('img', {
    staticClass: "user_avatar",
    attrs: {
      "src": "http://test.fe.ptdev.cn/elm/elmlogo.jpeg"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "rating_list_details"
  }, [_c('header', [_c('section', {
    staticClass: "username_star"
  }, [_c('p', {
    staticClass: "username"
  }, [_vm._v("4*******b")])]), _vm._v(" "), _c('time', {
    staticClass: "rated_at"
  }, [_vm._v("2017-02-10")])]), _vm._v(" "), _c('article', [_vm._v("\n                                          真心是不错的真心是不错的真心是不错的真心是不错的真心是不错的\n                                      ")])])]), _vm._v(" "), _c('li', {
    staticClass: "rating_list_li"
  }, [_c('img', {
    staticClass: "user_avatar",
    attrs: {
      "src": "http://test.fe.ptdev.cn/elm/elmlogo.jpeg"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "rating_list_details"
  }, [_c('header', [_c('section', {
    staticClass: "username_star"
  }, [_c('p', {
    staticClass: "username"
  }, [_vm._v("4*******b")])]), _vm._v(" "), _c('time', {
    staticClass: "rated_at"
  }, [_vm._v("2017-02-10")])]), _vm._v(" "), _c('article', [_vm._v("\n                                         专业水军\n                                      ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e2d8c15","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/comment/commentlist.vue
// module id = 480
// module chunks = 1